<template>
  <page-content v-has-permission="'permission_view'">

    <panel ref="searchFormPanel" show-close show-collapse title="Thông tin tìm kiếm" :is-open.sync="showFormSearch">
      <c-form ref="searchForm" @submit="search()">

        <b-row>
          <b-col>
            <c-select2 v-model.number="searchForm.resourceId"
                       label="Tài nguyên"
                       placeholder="Nhập mã tài nguyên"
                       uri="cms/api/v1.0/admin/resources/select2"
            />
          </b-col>
          <b-col>
            <c-select2 v-model.number="searchForm.actionId"
                       label="Hành động"
                       placeholder="Nhập tên shop hoặc mã shop"
                       uri="cms/api/v1.0/admin/actions/select2"
            />
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
            <button class="btn btn-secondary" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel" show-collapse title="Danh sách hành động">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="searchForm"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã quyền', sortField:'code', sortable: true},
                   {text: 'Người tạo', sortField:'createdBy', sortable: true},
                   {text: 'Thời gian tạo', sortField:'createdAt', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/cms/api/v1.0/admin/permission/get-all"
      >
        <template #button>
          <b-button size="sm"
                    variant="success"
                    @click="$refs.formCreate.open()"
                    v-has-permission="'permission_create'"
          >
            <i class="fas fa-plus-circle"></i> Thêm mới
          </b-button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.createdBy }}</td>
          <td>{{ item.createdAt | datetime }}</td>
          <td class="text-center">
            <!--            <b-button-->
            <!--                class="btn btn-icon"-->
            <!--                title="Danh sách uri"-->
            <!--                type="button"-->
            <!--                variant="success"-->
            <!--            >-->
            <!--              <i class="far fa-globe-americas"></i>-->
            <!--            </b-button>-->

            <b-button
                class="btn btn-icon"
                title="Xóa"
                type="button"
                variant="danger"
                @click="deleteItem(item)"
                v-has-permission="'permission_delete'"
            >
              <i class="far fa-trash-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

    <add ref="formCreate" @success="search()"/>
    <delete ref="deleteConfirmDialog" @success="search()"/>
  </page-content>
</template>

<script>
import Add from './Add';
import Delete from './Delete';

export default {
  name: "Index",
  components: {
    Add,
    Delete,
  },
  data() {
    return {
      searchForm: {
        resourceId: null,
        actionId: null,
      },
      showFormSearch: false
    }
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    resetFormSearch() {
      this.searchForm.resourceId = null;
      this.searchForm.actionId = null;

      this.search();
    },
    update(item) {
      this.$refs.formUpdate.open(item.id);
    },
    deleteItem(item) {
      this.$refs.deleteConfirmDialog.open(item);
    }
  }
}
</script>

<style scoped>

</style>